<template>
  <div class="relative flex items-center even:bg-neutral-50 pr-4">
    <slot name="image" />
    <div class="font-semibold w-full pr-2">
      <slot />
    </div>
    <slot name="actions" />
  </div>
</template>
